import { Typography } from 'components/DesignSystemV2/Typography';
import {
  ChatBubbleSparkleIcon,
  IconsContentQuote
} from 'components/Icon/SVGIcons';
import OutlinedButton from 'components/OutlinedButton';
import { ResponsiveContainer } from 'components/ResponsiveContainer';
import { ReviewCard } from 'components/ReviewCard';
import { SectionV3 } from 'components/SectionV3';
import React, { useMemo, useState } from 'react';
import Modal from 'shared/CourseLanding/Modal';
import VideoInline from 'shared/VideoThumbnailInline/VideoInline';
import { desktopFirstV3 } from 'style/breakpointsv3';
import { colorsV2 } from 'style/colors-v2';
import styled from 'styled-components';
import { toScreen } from 'utils/media-query/responsive.util';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderTitle = styled.div`
  text-align: center;
  max-width: 400px;
  margin: 0 auto;

  ${toScreen(desktopFirstV3.md)} {
    max-width: 380px;
  }

  ${toScreen(desktopFirstV3.sm)} {
    max-width: 100%;
  }
`;

const HeaderSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

const Content = styled.div`
  margin-top: 64px;
  margin-bottom: 64px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;

  ${toScreen(desktopFirstV3.md)} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const VideoElement = styled(VideoInline)`
  video {
    border-radius: 8px;
  }
  > div {
    margin-bottom: 0;
  }
`;

const LoadmoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PAGE_SIZE = 4;

const ReviewWithVideoSection = ({
  data,
  footerTitle = '',
  videoPosition = 'right'
}) => {
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = React.useState(false);
  const [videoUrl, setVideoUrl] = React.useState('');

  const { title, subheader, reviews } = data;

  const paginatedReviews = useMemo(() => {
    return reviews.slice(0, page * PAGE_SIZE);
  }, [page, reviews]);

  return (
    <SectionV3>
      <ResponsiveContainer>
        <Header>
          <HeaderTitle>
            <ChatBubbleSparkleIcon />
            <Typography
              variant="bold/24-32"
              tabletVariant="bold/32-40"
              desktopVariant="bold/40-48"
              color={colorsV2.black100}
              v3
            >
              {title}
            </Typography>
          </HeaderTitle>
          {subheader && (
            <HeaderSubtitle>
              {subheader.title && (
                <Typography
                  variant="semi-bold/24-32"
                  color={colorsV2.neutral200}
                  v3
                >
                  {subheader.title}
                </Typography>
              )}
              {subheader.description && (
                <Typography
                  variant="regular/14-20"
                  color={colorsV2.neutral180}
                  v3
                >
                  {subheader.description}
                </Typography>
              )}
            </HeaderSubtitle>
          )}
        </Header>
        <Content>
          {paginatedReviews.map((review, idx) => (
            <ReviewCard
              key={idx}
              review={review}
              footerTitle={footerTitle}
              videoPosition={videoPosition}
              onPlayVideo={videoUrl => {
                setVideoUrl(videoUrl);
                setShowModal(true);
              }}
            />
          ))}
        </Content>
        {reviews.length > paginatedReviews.length && (
          <LoadmoreWrapper>
            <OutlinedButton onClick={() => setPage(page + 1)}>
              Xem thêm <IconsContentQuote color={colorsV2.neutral140} />
            </OutlinedButton>
          </LoadmoreWrapper>
        )}
        <Modal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
          <VideoElement
            onContextMenu={e => e.preventDefault()}
            video={videoUrl}
            alt="talk-about-dol-english"
            controlsList="nodownload"
            isAutoPlay
          />
        </Modal>
      </ResponsiveContainer>
    </SectionV3>
  );
};

export default ReviewWithVideoSection;
